/* Utils */
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

/* Store */
import useModalStore from 'Stores/Modals';
import useFurnituresStore from 'Stores/Furnitures';
import useCategoriesStore from 'Stores/Categories';
import useProductsStore from 'Stores/Products';

/* Components */
import Icon from 'Components/Icon';
import Modal from 'Components/Modal';
import FormInput from 'Components/FormInput';
import FormSelect from 'Components/FormSelect';
import FormInputAutocomplete from 'Components/FormInputAutocomplete';

/* Styles */
import './style.scss';

const FurnitureItem = (props) => {
	const {
		furniture, onDeleteItem, onFurnitureStockChange
	} = props;
	const [value, setValue] = useState(furniture.stockUsed);
	const [error, setError] = useState(false);

	useEffect(() => {
		if (value === '') {
			setError(true);
		} else {
			setError(false);
		}
	}, [value]);

	return (
		<div className="tag-item">
			<span className="tag-item-name">
				<Icon onClick={() => onDeleteItem(furniture)} name="utilitary_close" isHM />
				{furniture.name}
			</span>
			<input
				className={`tag-item-stock ${error ? 'error' : ''}`}
				name="tag-stock"
				value={value}
				onChange={(e) => setValue(e.target.value)}
				onBlur={() => onFurnitureStockChange({ id: furniture.id, value: parseInt(value, 10) })}
			/>
		</div>
	);
};

FurnitureItem.propTypes = {
	furniture: PropTypes.instanceOf(Object).isRequired,
	onDeleteItem: PropTypes.func.isRequired,
	onFurnitureStockChange: PropTypes.func.isRequired
};

const CreateProduct = () => {
	// Store
	const hideModal = useModalStore(store => store.hideModal);
	const furnitures = useFurnituresStore(store => store.furnitures);
	const fetchFurnitures = useFurnituresStore(store => store.fetchFurnitures);
	const categories = useCategoriesStore(store => store.categories);
	const fetchCategories = useCategoriesStore(store => store.fetchCategories);
	const createProduct = useProductsStore(store => store.createProduct);
	const history = useHistory();

	// State
	const [form, setForm] = useState({
		name: '',
		category: '',
		furnitures: []
	});

	const getOptions = () => categories && categories.map(category => ({ label: category.name, value: category.id }));
	const handleHideModal = () => {
		history.push('/inventory/products');
		hideModal();
	};
	const handleSubmit = async () => {
		const params = {
			...form,
			furnitures: { datas: form.furnitures }
		};
		await createProduct(params);
		handleHideModal();
	};

	useEffect(() => {
		if (!furnitures) {
			fetchFurnitures();
		}

		if (!categories) {
			fetchCategories();
		}
	}, []);

	const navigation = { icon: 'utilitary_close', action: () => handleHideModal() };
	const button = { label: 'Sauvegarder', action: () => handleSubmit() };

	return (
		<Modal title="Créer un nouveau produit" navigation={navigation} button={button}>
			<div className="default-modal wrapper">
				<div className="default-modal-content">
					<h2>Création du produit</h2>

					<div className="produts-inputs">
						<FormInput
							name="name"
							label="Nom du produit"
							placeholder="Ex: Collier corne lune"
							value={form.name}
							setValue={(value) => setForm({ ...form, name: value })}
						/>
						<FormSelect
							name="category"
							label="Catégorie du produit"
							value={form.category}
							options={getOptions() || []}
							setValue={(value) => setForm({ ...form, category: value })}
						/>
					</div>

					{ furnitures && (
						<div className="product-furnitures">
							<div className="product-furnitures-selection">
								<p className="metricTitle">Sélection des fournitures utilisées par le produit</p>
								<p>Remplir le stock utilisé par une fourniture (ex: 50cm de chaine, 2 fermoirs ...)</p>
								<p>Si la fourniture est optionnelle, mettre 0, sinon elle sera automatiquement décomptée lors d&apos;une commande</p>
								<FormInputAutocomplete
									name="tagQuery"
									label="Rechercher une fourniture"
									datas={furnitures.filter(furniture => !form.furnitures.find(item => item.id === furniture.id))}
									field="name"
									placeholder="Ex: chaine simple"
									callback={(furniture) => {
										const productFurnitures = form.furnitures;
										const item = {
											id: furniture.id,
											name: furniture.name,
											stockUsed: 1
										};
										setForm({ ...form, furnitures: [...productFurnitures, item] });
									}}
								/>

								{ form.furnitures && form.furnitures.length > 0 && (
									<div className="tags">
										{ form.furnitures.map(furniture => (
											<FurnitureItem
												key={Math.random()}
												furniture={furniture}
												onDeleteItem={(deleteFurniture) => {
													const newFurnitures = [...form.furnitures.filter(item => item.id !== deleteFurniture.id)];
													setForm({ ...form, furnitures: newFurnitures });
												}}
												onFurnitureStockChange={(newStock) => {
													const productFurnitures = form.furnitures.map(item => {
														if (item.id === newStock.id) {
															item.stockUsed = newStock.value;
														}
														return item;
													});

													setForm({ ...form, furnitures: productFurnitures });
												}}
											/>
										)) }
									</div>
								)}
							</div>

							{/* <div className="product-furnitures-selection optional">
								<p className="metricTitle">Sélectionner les variants<br />(chaine, pendentif, pierres)</p>
								<FormInputAutocomplete
									name="tagQueryVariant"
									label="Rechercher une fourniture"
									datas={furnitures}
									field="name"
									callback={(tag) => setTagsVariants([...tagsVariants, tag])}
								/>

								{ tagsVariants && tagsVariants.length > 0 && (
									<div className="tags">
										{ tagsVariants.map(tag => (
											<FurnitureItem
												key={Math.random()}
												tag={tag}
												onDeleteItem={deleteTag => setTagsVariants([...tagsVariants.filter(t => t.id !== deleteTag.id)])}
											/>
										))}
									</div>
								)}
							</div> */}
						</div>
					)}
				</div>
			</div>
		</Modal>
	);
};

export default CreateProduct;
